import { Location } from '@angular/common'
import { inject } from '@angular/core'
import { CanActivateFn, Router, UrlTree } from '@angular/router'
import { Role } from '@interfaces'
import { AuthService } from '@services'
import { Observable, map, tap } from 'rxjs'

export const isNotLoggedInGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
	const route = inject(Router)

	return inject(AuthService).isLoggedIn$.pipe(
		map(isLoggedIn => {
			const result = isLoggedIn || route.createUrlTree(['/login'])
			console.debug('[auth] isNotLoggedInGuard', {
				isLoggedIn,
				redirectTo: result === true ? null : '/login'
			})
			return result
		})
	)
}

export const isLoggedInGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
	const route = inject(Router)

	return inject(AuthService).isLoggedIn$.pipe(
		map(isLoggedIn => {
			const result = !isLoggedIn || route.createUrlTree(['/subscribers'])
			console.debug('[auth] isLoggedInGuard', {
				isLoggedIn,
				redirectTo: result === true ? null : '/subscribers'
			})
			return result
		})
	)
}

export const hasRoleGuard = (allowedRoles: Role[]): CanActivateFn => {
	return () => {
		const locationService = inject(Location)
		return inject(AuthService).user$.pipe(
			map(user => Boolean(user && allowedRoles.every(role => user.roles.includes(role)))),
			tap(hasRole => hasRole === false && locationService.back())
		)
	}
}

export const denyBarGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
	const router = inject(Router)
	return inject(AuthService).user$.pipe(
		map(user => {
			const isBar = user?.roles?.includes('CAN_MANAGE_BAR_SUBSCRIBER') ?? false
			return isBar ? router.createUrlTree(['/subscribers']) : true
		})
	)
}

export const setURLStateFromQuery: CanActivateFn = (): boolean => {
	const router = inject(Router)

	const currentNavigation = router.getCurrentNavigation()
	const currentState = currentNavigation?.extras.state || {}
	const queryParams = currentNavigation?.extractedUrl.queryParams || {}

	if (Object.keys(queryParams).length > 0) {
		const newState = { ...currentState, ...queryParams }
		const currentUrl = currentNavigation?.finalUrl?.toString().split('?')[0] || router.url

		router.navigate([currentUrl], {
			state: newState,
			queryParams: {},
			queryParamsHandling: 'merge' // No afecta al estado, pero asegura el manejo correcto
		})

		return false // Detenemos la navegación original y forzamos la redirección
	}

	// Si no hay queryParams, permitir la navegación
	return true
}
